export default __webpack_public_path__ + "static/assets/ae69452028161eddf7a68283600553b9.jpg";